import { render, staticRenderFns } from "./project-tab-tasks.vue?vue&type=template&id=5f6dee30&scoped=true"
import script from "./project-tab-tasks.vue?vue&type=script&lang=ts"
export * from "./project-tab-tasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6dee30",
  null
  
)

export default component.exports